export const getInitialPlayerTags = (_playerId: string): string[] => {
  // No mock tags - players start with no tags until user adds them
  return [];
};
